import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { SvgIcon } from '@material-ui/core';
import TooltipEnclosure from './TooltipEnclosure';
import { WarningOutline as WarningIcon } from './Icons';

const useStyles = makeStyles(() => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
  },
}));

const TooltipWarning = ({ className = '', title = '', color = '' }) => {
  const classes = useStyles();

  return (
    <TooltipEnclosure title={title} className={`${classes.root} ${className}`}>
      <SvgIcon component={WarningIcon} style={{ color: color }} />
    </TooltipEnclosure>
  );
};

export default TooltipWarning;
